import { Chip } from "@gigpro/ui/Chip";
import { useAdminProW2EmploymentStatus } from "api/queries/admin";

/** "W-2 Onboarded" / "W-2 Terminated"; nothing for a pro who never finished W-2 onboarding. */
export function W2EmploymentStatusChip({ proId }: Readonly<{ proId: number }>) {
  const { data: status } = useAdminProW2EmploymentStatus(proId);

  if (status === "onboarded") return <Chip className="bg-success text-large text-white">W-2 Onboarded</Chip>;
  if (status === "terminated") return <Chip className="bg-error text-large">W-2 Terminated</Chip>;
  return null;
}
